<template>
<div class="mt_140">

        <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
        <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

        <div class="container">
        <div class="row">
        <div class="col-md-12">

          <!-- row -->
          <div class="row">

              <!-- coluna 2 -->
              <div class="col-md-2">
                <ccMenuConta :num=7></ccMenuConta>
              </div">
              <!-- fim coluna 2 -->

              <!-- coluna 10 -->
              <div class="col-md-10 p-5" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">


                  <!-- TOPO -->
                  <section>
                    <div class="row">

                      <div class="col-12 mb-3">
                        <button class="btn btn-outline-danger w-100 btn-sm mb-3">STATUS DA CONTA</button>
                      </div>

                      <div class="col-12 mb-3">

                        <div v-if="anexo_rg_file == null" class="input-group">
                          <label class="form-label text_cinza">Documento de RG</label>
                          <div class="input-group">
                            <input type="file" class="form-control" id="file1" name="file1" required>
                            <button class="btn btn-secondary" @click="send_documento('rg')">Enviar </button>
                          </div>
                        </div>
                        <div v-else>
                          <label class="form-label text_cinza">Documento de RG em análise</label>
                          <div class="input-group">
                            <input class="form-control" v-model="anexo_rg_file" disabled>
                            <button class="btn btn-danger" @click="delete_documento(anexo_rg_id)"> Excluir </button>
                          </div>
                        </div>

                        <br><br>

                        <div v-if="anexo_cpf_file == null" class="input-group">
                          <label class="form-label text_cinza">Documento de CPF</label>
                          <div class="input-group">
                            <input type="file" class="form-control" id="file2" name="file2" required>
                            <button class="btn btn-secondary" @click="send_documento('cpf')">Enviar </button>
                          </div>
                        </div>
                        <div v-else>
                          <label class="form-label text_cinza">Documento de CPF em análise</label>
                          <div class="input-group">
                            <input class="form-control" v-model="anexo_cpf_file" disabled>
                            <button class="btn btn-danger" @click="delete_documento( anexo_cpf_id)"> Excluir </button>
                          </div>
                        </div>

                        <br><br>

                        <!-- <div v-if="anexo_residencia_file == null" class="input-group">
                          <label class="form-label text_cinza">Documento de Residência</label>
                          <div class="input-group">
                            <input type="file" class="form-control" id="file3" name="file3" required>
                            <button class="btn btn-secondary" @click="send_documento('residencia')">Enviar </button>
                          </div>
                        </div>
                        <div v-else>
                          <label class="form-label text_cinza">Documento de Residência em análise</label>
                          <div class="input-group">
                            <input class="form-control" v-model="anexo_residencia_file" disabled>
                            <button class="btn btn-danger" @click="delete_documento(anexo_residencia_id)"> Excluir </button>
                          </div>
                        </div> -->

                        <br><br>

                      </div>

                      <!--
                      <div class="col-12 mb-3">
                        <div v-if="anexo_rg == null">
                          <label for="exampleFormControlTextarea1" class="form-label text_cinza">Comprovante de Identidade</label>
                          <input class="form-control" type="file" id="file1" name="file1">
                        </div>
                        <div v-else class="input-group">
                          <button class="btn btn-secondary btn-sm" @click="delete_documento(anexo_rg)">X</button>  &nbsp; <b>{{anexo_rg}}</b>
                        </div>
                      </div>

                      <div class="col-12 mb-3">
                        <div v-if="anexo_cpf == null">
                          <label for="exampleFormControlTextarea1" class="form-label text_cinza">Comprovante de CPF</label>
                          <input class="form-control" type="file" id="file2" name="file2">
                        </div>
                        <div v-else class="input-group">
                          <button class="btn btn-secondary btn-sm" @click="delete_documento(anexo_cpf)">X</button>  &nbsp; <b>{{anexo_cpf}}</b>
                        </div>
                      </div>

                      <div class="col-12 mb-3">
                        <div v-if="anexo_residencia == null">
                          <label for="exampleFormControlTextarea1" class="form-label text_cinza">Comprovante de Residência</label>
                          <input class="form-control" type="file" id="file3" name="file3">
                        </div>
                        <div v-else class="input-group">
                          <button class="btn btn-secondary btn-sm" @click="delete_documento(anexo_residencia)">X</button>  &nbsp; <b>{{anexo_residencia}}</b>
                        </div>
                      </div>
                      -->

                      <div class="col-12 text_cinza text_12">
                        É preciso enviar uma cópia da sua identidade ou carteira de motorista, ou passaporte, alem de uma cópia de comprovante de residência com no máximo 3 meses, e o seu CPF. <br><br>
                        Sem isso vpcê não poderá efetuar saques em sua conta<br><br>
                        Cada arquivo não pode conter mais do que 2mb
                      </div>

                    </div>
                  </section>


              </div>
               <!-- fim coluna 10 -->

          </div>
          <!-- fim row -->

      </div>
      </div>
      </div>

      <ccFooter></ccFooter>
</div>
</template>

<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'VERIFIQUE SUA CONTA',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors: [],

      //variaveis
      anexo_rg_id: 0,
      anexo_cpf_id: 0,
      anexo_residencia_id: 0,

      anexo_rg_file: null,
      anexo_cpf_file: null,
      anexo_residencia_file: null,
    }
  },

  components: {ccMenu, TheMask, ccMenuConta, ccLoading, ccFooter},

  created()
  {
    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }else{ this.user = a }

    this.carregar_documentos_upados()
  },

  methods: {

    carregar_documentos_upados()
    {
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'conta/documentos/upados', header)
      .then(response => {

        this.anexo_rg_id = null
        this.anexo_cpf_id = null
        this.anexo_residencia_id = null

        this.anexo_rg_file = null
        this.anexo_cpf_file = null
        this.anexo_residencia_file = null

        var a = response.data
        for (var i=0; i <= a.length -1; i++){
          if(a[i].tipo == 'rg'){
            this.anexo_rg_id = a[i].id
            this.anexo_rg_file = a[i].file
          }

          if(a[i].tipo == 'cpf'){
            this.anexo_cpf_id = a[i].id
            this.anexo_cpf_file = a[i].file
          }

          if(a[i].tipo == 'residencia'){
            this.anexo_residencia_id = a[i].id
            this.anexo_residencia_file = a[i].file
          }
        }

      })
      .catch(e => {
        this.errors.push(e);
        this.loding = false;
      })
    },

    async send_documento(tipo)
    {
      var formData = new FormData();
      formData.append("tipo", tipo);
      if(tipo == 'rg'){ var imagefile1 = document.querySelector('#file1'); }
      if(tipo == 'cpf'){ var imagefile1 = document.querySelector('#file2'); }
      if(tipo == 'residencia'){ var imagefile1 = document.querySelector('#file3'); }
      formData.append("arquivo", imagefile1.files[0]);

      var header = {'headers': {'Content-Type':'multipart/form-data','x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'conta/documento/upload', formData, header)
      .then(response => {

        console.log( response.data )

        this.carregar_documentos_upados()

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
      })
    },

    delete_documento(n)
    {
      var body = {
        id: n,
      }

      var header = {'headers': {'Content-Type':'multipart/form-data','x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'conta/documento/delete', body, header)
      .then(response => {

        console.log(response.data)
        // this.carregar_documentos_upados()

      })
      .catch(e => {
        this.errors.push(e);
        this.loding = false;
      });
    },

  }

}
</script>

<style scoped>
  input.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
  }

  input.form-control.disabled{
    background-color: #21232d;
    opacity: 0.5;
  }

  select.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
  }
</style>



// WEBPACK FOOTER //
// src/components/conta/verificada.vue